import { trackProductEvent, type AnalyticsProperties } from '@/lib/analytics';

export const trackManualMealPlanSetupStarted = (properties: AnalyticsProperties) => {
  trackProductEvent('Manual Meal Plan Setup Started', properties);
};

export const trackAIMealPlanSetupStarted = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Setup Started', properties);
};

export const trackAddMealPlanClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('Add Meal Plan Clicked', properties);
};

export const trackMealPlanTypeSelected = (properties: AnalyticsProperties) => {
  trackProductEvent('Meal Plan Type Selected', properties);
};
